@let enableNewShiftDropZone =
  createNewViaDragAndDropService.showEmptyShiftDropZone$ | async;
@let enableNewAbsenceDropZone =
  createNewViaDragAndDropService.enableNewAbsenceDropZone$ | async;
@let enableShiftTemplateDropZone =
  createNewViaDragAndDropService.showShiftTemplateDropZone$ | async;
@let isMoveMode = dragAndDropModeService.isMoveMode$ | async;
@let draggingShift = dragAndDropModeService.draggingShiftV2$ | async;
@let showShiftDropZone = dragAndDropModeService.showShiftDropZone$ | async;
@let selectedAbsenceId = absenceDrawerHelperService.selectedAbsenceId$ | async;
@let isAbsenceDrawerVisible =
  absenceDrawerHelperService.isAbsenceDrawerVisible$ | async;
@let isShiftDrawerVisible = isShiftDrawerVisible$ | async;
@let pixelWidthPerDay = (pixelWidthPerDay$ | async)!;

<div [style.min-height.px]="defaultRowHeight">
  @if (enableNewShiftDropZone) {
    <wilson-new-shift-drop-zone-cell-view
      [userId]="user.id"
    ></wilson-new-shift-drop-zone-cell-view>
  }
  @if (enableNewAbsenceDropZone) {
    <wilson-new-absence-drop-zone-cell-view
      [userId]="user.id"
    ></wilson-new-absence-drop-zone-cell-view>
  }
  @if (enableShiftTemplateDropZone) {
    <wilson-shift-template-drop-zone-v2
      [userId]="user.id"
    ></wilson-shift-template-drop-zone-v2>
  }
  @if (!isMoveMode && draggingShift && showShiftDropZone) {
    <wilson-assign-shift-drop-zone-cell-view
      [userId]="user.id"
      (dragOverEvent)="
        assignShiftDropZoneCellViewHelperService.onDragOverHandler($event)
      "
      (dragLeaveEvent)="
        assignShiftDropZoneCellViewHelperService.onDragLeaveHandler($event)
      "
      (dropEvent)="
        assignShiftDropZoneCellViewHelperService.onDropHandler($event)
      "
    ></wilson-assign-shift-drop-zone-cell-view>
  }

  <div
    #innerRow
    class="innerRow"
    [ngStyle]="{
      'min-height': defaultRowHeight + 'px',
    }"
    [attr.data-test-id]="
      'wilson-timeline-cell-view-user-row-assignments:row-' + user.id
    "
    (contextmenu)="contextMenu($event, menu, innerRow)"
  >
    @let assignmentStacks = userDataRowsSubject | async;
    @if (assignmentStacks && assignmentStacks.length > 0) {
      <div class="d-flex">
        <ng-container
          *rxFor="
            let assignmentStack of assignmentStacks;
            let isLastShiftInRow = last;
            trackBy: trackByAssignmentStack
          "
        >
          @if (
            assignmentStack.shifts.length || assignmentStack.absences.length
          ) {
            <wilson-cell-view-assignment-card
              [isShiftDraggable]="
                !isAbsenceDrawerVisible && !isShiftDrawerVisible
              "
              [assignmentStack]="assignmentStack"
              [userId]="user.id!"
              [viewport]="parentElementRef"
              [isTooltipVisible]="!!isTooltipVisible"
              [draggingItemId]="dragAndDropModeService.draggingItemId$ | async"
              [isAbsenceDraggable]="
                !!isMoveMode && !isAbsenceDrawerVisible && !isShiftDrawerVisible
              "
              [isSelected]="
                (assignmentStack.absences | containsId: selectedAbsenceId) &&
                !!isAbsenceDrawerVisible
              "
              [pixelWidthPerDay]="pixelWidthPerDay"
              [isSelectionEnabled]="true"
              [enableHighlighting]="true"
              [modifiedShiftIds]="null"
              [isLastShiftInLastUserRow]="isLastUserRow && isLastShiftInRow"
              (absenceDragEnd)="
                moveAbsenceDropZoneHelperService.dragEnd(!!isMoveMode)
              "
              (absenceDragging)="startAbsenceDrag($event)"
              (selectAbsenceEvent)="openAbsenceDrawer($event)"
              (shiftDragStarted)="handleShiftDragStarted($event)"
              (shiftDragEnded)="handleShiftDragEnded()"
            ></wilson-cell-view-assignment-card>
          }
        </ng-container>
        @let cellsToHighlight =
          (timelineCellHighlightService.getUserCellsToHighlight(user.id!)
            | async) || [];
        @if (cellsToHighlight?.length) {
          <wilson-timeline-cell-highlight
            [userId]="user.id!"
            [cellsToHighlight]="cellsToHighlight"
            [dayWidth]="pixelWidthPerDay"
          ></wilson-timeline-cell-highlight>
        }
      </div>
    }
  </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <wilson-timeline-user-row-context-menu-wrapper></wilson-timeline-user-row-context-menu-wrapper>
</nz-dropdown-menu>
